import { parseHexRgb } from "./core/color";
export var colors = {
    background: "#aaaaaa",
    location: {
        starting: "#5555ff",
        final: "#00ff00",
        intermediate: "#ffffff",
        empty: "#004101",
        fail: "#d20000",
    },
    jump: {
        withDescription: {
            begin: parseHexRgb("#ffffff"),
            end: parseHexRgb("#0000ff"),
        },
        withoutDescription: {
            begin: parseHexRgb("#00ddff"),
            end: parseHexRgb("#00aaaa"),
        },
        sameTextWithDescription: {
            begin: parseHexRgb("#ffffff"),
            end: parseHexRgb("#800000"),
        },
        sameTextWithoutDescription: {
            begin: parseHexRgb("#f5c896"),
            end: parseHexRgb("#800000"),
        },
        empty: {
            begin: parseHexRgb("#ffffff"),
            end: parseHexRgb("#004000"),
        },
        /* what's this? sometimes jump arrow is painted so */
        arrow: "#0000ff",
    },
    backgroundJumpsStats: "#e7e298",
    unlimitedPassingJump: "#0000ff",
    limitedPassingJump: "#ff0000",
    selectionOutbound: "#000000",
    selectionInbound: "#ff8040",
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29sb3JzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxjQUFjLENBQUM7QUFFM0MsTUFBTSxDQUFDLElBQU0sTUFBTSxHQUFHO0lBQ3BCLFVBQVUsRUFBRSxTQUFTO0lBQ3JCLFFBQVEsRUFBRTtRQUNSLFFBQVEsRUFBRSxTQUFTO1FBQ25CLEtBQUssRUFBRSxTQUFTO1FBQ2hCLFlBQVksRUFBRSxTQUFTO1FBQ3ZCLEtBQUssRUFBRSxTQUFTO1FBQ2hCLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0QsSUFBSSxFQUFFO1FBQ0osZUFBZSxFQUFFO1lBQ2YsS0FBSyxFQUFFLFdBQVcsQ0FBQyxTQUFTLENBQUM7WUFDN0IsR0FBRyxFQUFFLFdBQVcsQ0FBQyxTQUFTLENBQUM7U0FDNUI7UUFDRCxrQkFBa0IsRUFBRTtZQUNsQixLQUFLLEVBQUUsV0FBVyxDQUFDLFNBQVMsQ0FBQztZQUM3QixHQUFHLEVBQUUsV0FBVyxDQUFDLFNBQVMsQ0FBQztTQUM1QjtRQUNELHVCQUF1QixFQUFFO1lBQ3ZCLEtBQUssRUFBRSxXQUFXLENBQUMsU0FBUyxDQUFDO1lBQzdCLEdBQUcsRUFBRSxXQUFXLENBQUMsU0FBUyxDQUFDO1NBQzVCO1FBQ0QsMEJBQTBCLEVBQUU7WUFDMUIsS0FBSyxFQUFFLFdBQVcsQ0FBQyxTQUFTLENBQUM7WUFDN0IsR0FBRyxFQUFFLFdBQVcsQ0FBQyxTQUFTLENBQUM7U0FDNUI7UUFDRCxLQUFLLEVBQUU7WUFDTCxLQUFLLEVBQUUsV0FBVyxDQUFDLFNBQVMsQ0FBQztZQUM3QixHQUFHLEVBQUUsV0FBVyxDQUFDLFNBQVMsQ0FBQztTQUM1QjtRQUNELHFEQUFxRDtRQUNyRCxLQUFLLEVBQUUsU0FBUztLQUNqQjtJQUVELG9CQUFvQixFQUFFLFNBQVM7SUFDL0Isb0JBQW9CLEVBQUUsU0FBUztJQUMvQixrQkFBa0IsRUFBRSxTQUFTO0lBQzdCLGlCQUFpQixFQUFFLFNBQVM7SUFDNUIsZ0JBQWdCLEVBQUUsU0FBUztDQUNuQixDQUFDIn0=